export default {"src":"/_next/static/media/thelaend_part_of_shape_color.8b4686be.svg","height":512,"width":466,"blurWidth":0,"blurHeight":0};